// extracted by mini-css-extract-plugin
module.exports = {"fuel-grade-differential":"FuelGradeDifferential_fuel-grade-differential__3jSUV"};